var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-card-list',_vm._l((_vm.incidents),function(incident,index){return _c('incident-card-list-entry',{key:incident.id,class:{'bg-gray-100' : index % 2 !== 0},attrs:{"interruption":incident,"hosts":incident.hosts}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }